"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var WindowOverviewFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowOverviewFilterConverter, _DataObjectConverter_);

  function WindowOverviewFilterConverter() {
    _classCallCheck(this, WindowOverviewFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewFilterConverter).apply(this, arguments));
  }

  return WindowOverviewFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowOverviewFilterConverter = WindowOverviewFilterConverter;